import platform from '@/shared/utils/platform';

import { RouterH5Enum } from '@/router/router-names';
import Bootstrap from '@/shared/utils/bootstrap';
import { sleep } from '@/shared/utils/sleep';
import RouterHelper from '@/shared/utils/routerHelper';
import router from '@/router';
import { local } from '@/shared/utils/storage';
import { LocalEnum } from '@/enums/local';

export enum LoginSessionEnum {
  LoginSmsRestart = 'LoginSmsRestart',
  LoginPhone = 'LoginPhone',
  LoginCaptcha = 'LoginCaptcha',
}

export default class LoginUtil {
  public static login(cb?: () => void): void {
    LoginUtil.cb = () => {
      if (cb) {
        cb();
      }
    };

    router.push({
      name: RouterH5Enum.login,
    });
  }

  public static cb?: () => void;

  public static async logout(jumpRouter = '/'): Promise<void> {
    if (platform.isHelloApp) return;
    await sleep();
    Bootstrap.initLoginUser(Object.create(null), Object.create(null));
    if (jumpRouter) {
      RouterHelper.navigate(jumpRouter);
    }
  }

  /**
   * 判断当前用户是否登陆金融账号
   * * */
  public static isLogin(): boolean {
    const user:Dictionary<Dictionary> | null = local.get(LocalEnum.FinanceUser);
    let loginRes = false;
    if (user !== null && user.hellobike && user.finance) {
      loginRes = !!(Object.keys(user.hellobike).length) && !!(Object.keys(user.finance).length);
    }
    return user !== null && loginRes;
  }
}
